/* eslint-disable prefer-promise-reject-errors */
import React, { useCallback, useEffect } from 'react'
import { connect } from 'dva'
import { Modal, Form, Input, Button, Cascader, Checkbox } from 'antd'
import { Link } from 'react-router-dom'
import { phoneValidator } from '@/utils'
import './Info.module.less'

const layout = {
  labelCol: { span: 4 },
  wrapperCol: { span: 20 },
}

const AddressModal = ({
  dispatch,
  addressVisible,
  isEditAddress,
  editAddress,
  areaList,
}) => {
  const [form] = Form.useForm()

  const handleCancel = useCallback(() => {
    dispatch({
      type: 'center/save',
      payload: {
        addressVisible: false,
      },
    })
    form.resetFields()
  }, [form, dispatch])

  const onFinish = useCallback(
    // 排除agree
    ({ agree, ...values }) => {
      if (isEditAddress) {
        dispatch({
          type: 'center/editPersonalAddress',
          payload: {
            body: {
              ...values,
            },
            query: {
              id: editAddress.id,
            },
          },
        }).then(() => {
          handleCancel()
          dispatch({
            type: 'global/getUserAddress',
          })
        })
      } else {
        dispatch({
          type: 'center/addPersonalAddress',
          payload: {
            params: {
              ...values,
              isDefault: 0,
            },
          },
        }).then(() => {
          handleCancel()
          dispatch({
            type: 'global/getUserAddress',
          })
        })
      }
    },
    [isEditAddress, dispatch, editAddress.id, handleCancel]
  )

  const changeSelectArea = useCallback(
    (value, selectedOptions) => {
      let area = ''
      selectedOptions.forEach((item) => {
        area += item.label
      })
      form.setFieldsValue({
        area,
      })
    },
    [form]
  )
  const onAgreeChange = (e) => {
    form.setFieldsValue({
      agree: e.target.checked ? true : undefined,
    })
  }

  useEffect(() => {
    if (addressVisible && isEditAddress) {
      form.setFieldsValue({
        receiver: editAddress.receiver,
        phone: editAddress.phone,
        area: editAddress.area,
        areaIds: editAddress.areaIds,
        addressDetail: editAddress.addressDetail,
      })
    }
  }, [
    form,
    addressVisible,
    isEditAddress,
    editAddress.receiver,
    editAddress.phone,
    editAddress.area,
    editAddress.areaIds,
    editAddress.addressDetail,
  ])

  return (
    <Modal
      className="modal"
      centered
      width={738}
      title="新增地址"
      visible={addressVisible}
      footer={null}
      onCancel={handleCancel}
    >
      <Form
        {...layout}
        name="basic"
        labelAlign="left"
        form={form}
        initialValues={{ remember: true }}
        onFinish={onFinish}
      >
        <Form.Item
          label="收件人"
          name="receiver"
          rules={[{ required: true, message: '请输入收件人' }]}
        >
          <Input placeholder="请输入收件人" />
        </Form.Item>

        <Form.Item
          label="联系电话："
          name="phone"
          required
          rules={[{ validator: phoneValidator }]}
        >
          <Input maxLength={11} placeholder="请输入手机号码" />
        </Form.Item>
        <Form.Item
          label="所在地区"
          name="areaIds"
          rules={[{ required: true, message: '选择所在地区' }]}
        >
          <Cascader
            onChange={changeSelectArea}
            options={areaList}
            placeholder="选择所在地区"
          />
        </Form.Item>
        <div style={{ display: 'none' }}>
          <Form.Item label="" name="area">
            <i />
          </Form.Item>
        </div>
        <Form.Item
          label="详细地址"
          name="addressDetail"
          rules={[{ required: true, message: '请选择邮寄地址' }]}
        >
          <Input placeholder="请选择邮寄地址(目前只向中国大陆寄送)" />
        </Form.Item>
        <Form.Item
          name="agree"
          rules={[
            {
              required: true,
              message: '请同意隐私协议',
            },
          ]}
        >
          <span style={{ color: '#ff8534', marginRight: '8px' }}>*</span>
          <Checkbox onChange={onAgreeChange}>
            同意
            <Link to="/policy/privacy" style={{ color: '#056DE8' }}>
              隐私协议
            </Link>
          </Checkbox>
        </Form.Item>
        <div style={{ marginTop: '30px', textAlign: 'center' }}>
          <Button style={{ width: '88px' }} type="primary" htmlType="submit">
            保存地址
          </Button>
        </div>
      </Form>
    </Modal>
  )
}

export default connect(({ center, global }) => {
  return {
    addressVisible: center.addressVisible,
    isEditAddress: center.isEditAddress,
    editAddress: center.editAddress,
    areaList: global.areaList,
  }
})(AddressModal)
